export function getCorsOriginsCacheKey(projectId: string) {
  return ['project', projectId, 'cors']
}
